// English strings (source language): sidebar.

const en = {
  brandLabel: 'Gruvetto, dashboard',
  menu: 'Menu',
  connections: 'Connections',
  nav: {
    home: 'Dashboard',
    play: 'Play',
    events: 'Events',
    challenges: 'Legends',
    online: 'Online',
    training: 'Training',
    store: 'Store',
    workshop: 'Workshop',
    wardrobe: 'Wardrobe',
    activities: 'Activities',
    progress: 'Progress',
    friends: 'Friends',
    club: 'Club',
    leaderboards: 'Leaderboards',
    settings: 'Settings',
    tutorials: 'Tutorials',
  },
  sections: { ride: 'Ride', me: 'Profile', create: 'Create' },
  /** Sections that group several screens as tabs. */
  hubs: { play: 'Play', journal: 'Progress', community: 'Community' },
  /** Tab labels when they differ from the menu's. */
  tabs: { play: 'Race', wardrobe: 'My rider', progress: 'Level & achievements' },
  chips: { account: 'Account', trainer: 'Smart trainer', hr: 'Heart rate', ride: 'Controllers: Zwift, phone or gamepad', net: 'Online server' },
  labels: { trainer: 'Smart trainer', hr: 'Heart rate', ride: 'Controllers', net: 'Online' },
  connecting: ' · connecting…',
  rideConnected: 'Controllers connected',
  phoneConnected: 'Phone controller',
  syncing: ' · syncing…',
  offline: ' · offline',
  signedOut: 'Signed out',
  friendRequests: (n: number) => `${n} friend request${n === 1 ? '' : 's'}`,
  room: (code: string) => `Room ${code}`,
  serverOn: 'Server connected',
};
export default en;
